import Dialog from '@mui/material/Dialog'
import DialogTitle from '@mui/material/DialogTitle'
import DialogContent from '@mui/material/DialogContent'
import DialogContentText from '@mui/material/DialogContentText'
import DialogActions from '@mui/material/DialogActions'
import Button from '@mui/material/Button'

/**
 * @param {{
 *   open?: boolean,
 *   onClose?: () => void,
 *   onExtend?: () => void,
 *   onSignOut?: () => void,
 *   title?: string,
 *   message?: string,
 *   expiryMessage?: string,
 *   staySignedInLabel?: string,
 *   signOutLabel?: string,
 * }} props
 */
export default function SessionAlert({
  open,
  onClose,
  onExtend,
  onSignOut,
  title = 'Session Timeout Warning',
  message = 'You’ve been inactive for a while. For your security, you will be signed out soon unless you choose to stay signed in.',
  expiryMessage = 'Session expires in 1 minute',
  staySignedInLabel = 'Stay signed in',
  signOutLabel = 'Sign out now',
}) {
  return (
    <Dialog
      open={!!open}
      onClose={onClose}
      aria-labelledby="session-timeout-warning-title"
      disableScrollLock
    >
      <DialogTitle id="session-timeout-warning-title">{title}</DialogTitle>
      <DialogContent>
        <DialogContentText>{message}</DialogContentText>
        <DialogContentText sx={{ mt: 1, fontWeight: 'medium' }}>
          {expiryMessage}
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={onSignOut}>
          {signOutLabel}
        </Button>
        <Button onClick={onExtend} variant="contained" color="primary" sx={{ minWidth: 96 }}>
          {staySignedInLabel}
        </Button>
      </DialogActions>
    </Dialog>
  )
}
